import { useFormik } from "formik";
import * as yup from "yup";
import { useEffect } from "react";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { useInvoice } from "../../../hooks/invoice/useInvoice";

export const useAffirmForm = ({ showTipsModal }) => {
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();
  const { invoice, amountToPay } = useInvoice();

  const schema = yup.object({
    phoneNumber: yup
      .string()
      .required(tSales("checkoutInvoice.formError.phoneNumberRequired"))
      .test(
        "valid-phone-number",
        tSales("checkoutInvoice.formError.validPhoneNumberRequired"),
        (value) =>
          isValidPhoneNumber(
            value || "",
            invoice?.patient?.country?.countryCode?.toUpperCase(),
          ),
      ),
    email: yup
      .string()
      .email(tCommon("formError.emailInvalid"))
      .required(tSales("checkoutInvoice.formError.emailRequired")),
    country: yup.object(),
  });

  const form = useFormik({
    initialValues: {
      phoneNumber: invoice?.patient?.phoneNumber || "",
      email: invoice?.patient?.email || "",
      amount: amountToPay || "",
      country: { label: "United States", value: "US" },
    },
    validationSchema: schema,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: () => {
      showTipsModal.update(true);
    },
  });

  useEffect(() => {
    form.setFieldValue("amount", amountToPay || "");
  }, [amountToPay]);

  return form;
};
